import http from "./http.js";
const getAreaList = () => {
    return new Promise((resolve)=>{
        http.get("/type/findRegionTreeByCode?code=520000000000&depth=2").then((res) => {
            resolve(res.data.address);
        });
    })
};
let areaInfo = getAreaList();
export default {
    areaList:areaInfo,
};
